import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../i18n/useTranslation';

interface AreaOfDevelopmentProps {
  id: string;
  name: string;
  img?: string;
  backgroundColor: string;
  mode?: 'waiting' | 'current' | 'finished'
  extraUrl?: string;
  currentLabel?: string;
}

const AreaOfDevelopment: React.FC<AreaOfDevelopmentProps> = ({
  id,
  name,
  img,
  backgroundColor,
  mode = 'waiting',
  extraUrl,
  currentLabel,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(`/career/${id}${extraUrl ?? ''}`, mode === 'current' ? { state: { fromCurrent: true } } : undefined);
  }, [navigate, id, extraUrl, mode]);

  const opacity = useMemo(() => {
    if (mode === 'finished') return 0.4;
    return 1;
  }, [mode]);

  return (
    <div
      className="w-full rounded-[20px] flex items-center max-w-115 min-h-20.5 py-4 cursor-pointer px-13 justify-between relative overflow-hidden"
      style={{
        backgroundColor: backgroundColor,
        opacity: opacity,
      }}
      onClick={handleClick}
    >
      <div className='flex flex-col'>
        {mode === 'current' && <p className="text-xs text-white leading-relaxed line-clamp-1">{currentLabel ?? t('course.area.current')}</p>}
        <h3
          className={`text-white text-xl font-bold ${img ? 'max-w-35' : 'max-w-full'} wrap-break-words leading-none shrink-0`}
          style={{ opacity: opacity }}
          >
          {name}
        </h3>
      </div>
      {img && (
        <img
          src={img}
          alt={t('course.area.image_alt', { name })}
          className="w-1/2 h-auto object-cover absolute right-0"
          style={{ opacity: opacity }}
        />
      )}
    </div>
  );
};

export default AreaOfDevelopment;
